import React, { useEffect } from 'react';
// import { Switch } from 'react-router-dom';
// import { routes } from './configs/routes';
// import QaseRouter from './QaseRouter';
import Router from './router/Router';
import { clarity } from 'react-microsoft-clarity';

import { useSelector } from 'react-redux';
import { getAuth } from './redux/selectors';

import 'react-perfect-scrollbar/dist/css/styles.css';
// import axios from 'axios';

const App = () => {
    const { loggedUser, loggedIn } = useSelector(getAuth);

    useEffect(() => {
        if (loggedIn && clarity.hasStarted()) {
            clarity.identify(loggedUser.emailAddress, {
                displayName: `${loggedUser?.firstName || ''} ${
                    loggedUser?.lastName || ''
                }`,
                email: loggedUser.emailAddress,
                userType: loggedUser.roles[0].name,
            });
            clarity.setTag('user_email', loggedUser.emailAddress);
        }
    }, [loggedUser, loggedIn]);

    // const handleSetClarityTags = async () => {
    //     const data = await axios.get('http://ip-api.com/json');
    //     if (data.status === 200) {
    //         clarity.setTag('state', data.data.regionName);
    //     }
    // };

    // useEffect(() => {
    //     handleSetClarityTags();
    // }, []);

    return <Router />;
};

export default App;
